import type { ColorsClassesConfig } from '../types'

export const ColorsClassesPresets: ColorsClassesConfig = [
  {
    prefix: 'bg',
    property: 'background-color',
  },
  {
    prefix: 'text',
    property: ['color', 'fill'],
  },
]
